"use client"

import { RadioButton, Text } from "@/elements"
import clsx from "clsx"
import type { FC } from "react"
import type { SubscriptionPlan } from "../useSubscriptionCheckoutModal"
interface PlanRowProps {
  plan: SubscriptionPlan
  selected: boolean
  onSelectPlan: (planId: string) => void
  selectedPlanId: string | null
  eligibleForTrial: boolean
}

export const PlanRow: FC<PlanRowProps> = ({ plan, selected, onSelectPlan, selectedPlanId, eligibleForTrial }) => {
  return (
    <div
      key={plan.name}
      onClick={() => onSelectPlan(plan.priceId)}
      className={clsx(
        selected ? "border-primary-3" : "border-bg-3 transition-colors hover:border-bg-4",
        selected ? "bg-pro-gradient-100" : "bg-bg-1",
        "border-border-1 flex h-[90px] cursor-pointer select-none flex-row items-center justify-between rounded-lg border bg-bg-1 p-[18px]"
      )}>
      <div className="flex flex-col gap-1">
        <Text variant="h6" className="">
          {plan.name}
        </Text>
        {eligibleForTrial && (plan.productType === "monthly" || plan.productType === "yearly") && (
          <Text variant="body2" className="text-fg-2">
            $0 today, 7 day free trial
          </Text>
        )}
      </div>

      <div className="flex flex-row items-center gap-4">
        <div className="text-right">
          <Text variant="h6">{plan.priceDisplay}</Text>
          {plan.productType === "yearly" && plan.yearlySavings ? (
            <div
              className="mt-[6px] inline-block rounded-[6px] px-[10px] py-[5px]"
              style={{
                background: "linear-gradient(134deg, #D1C3FB 0%, #D1B8EF 48.56%, #E8B6C4 100%)",
              }}>
              <Text
                style={{
                  lineHeight: "120%",
                  letterSpacing: "0.36px",
                  fontWeight: "500",
                }}
                variant="body3">
                SAVE ${Math.floor(plan.yearlySavings)}/YR
              </Text>
            </div>
          ) : null}
          {plan.productType === "daily" ? (
            <Text className="text-fg-2" variant="body2">
              One-time purchase
            </Text>
          ) : null}
        </div>
        <div className="hidden sm:block">
          <RadioButton checked={selectedPlanId === plan.priceId} value={""} size="large" />
        </div>
      </div>
    </div>
  )
}
